import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import "./NormalTabs.css";

function NormalTabs(props) {
    function a11yProps(index) {
        return {
            id: `vertical-tab-${index}`,
            'aria-controls': `vertical-tabpanel-${index}`,
        };
    }
    return (
        <div>
            <Tabs
                orientation={props.orientation}
                variant="scrollable"
                value={props.value}
                onChange={props.change}
                aria-label="Vertical tabs example"
                className={props.ContainerStyle}
            >
                {props.TabsOptions.map((option, index) => (
                    <Tab
                    key={index} 
                        className={props.TabStyle}
                        icon={option.icon}
                        label={option.label}
                        disabled={option.disabled}
                        {...a11yProps(index)}
                        onClick={() => props.onclick(index)}
                    />
                ))}
            </Tabs>
        </div>
    );
}

export default NormalTabs;